module.exports = __webpack_public_path__ + "static/media/discover-incentives-red.b48aa105.svg";